﻿import { forwardRef, useEffect, useImperativeHandle, useMemo, useState } from "react";
import { IDoesFilterPassParams, IFilterParams } from "@ag-grid-community/core";
import { Box, Select } from "@chakra-ui/react";
import { DesignatedZoneType, displayZone } from "../../../../api/models/EntityCandidate";

const DesignatedZoneFilter = forwardRef((props: IFilterParams<{ status: DesignatedZoneType }>, ref) => {
    const [filterValue, setFilterValue] = useState<DesignatedZoneType | undefined>();

    const filterOptions = useMemo(
        () =>
            Object.keys(DesignatedZoneType)
                .map(value => value as DesignatedZoneType)
                .map(zone => (
                    <option key={zone} value={zone}>
                        {displayZone(zone)}
                    </option>
                )),
        []
    );

    useImperativeHandle(ref, () => {
        return {
            doesFilterPass(params: IDoesFilterPassParams<{ status: DesignatedZoneType }>) {
                if (filterValue === undefined) {
                    return true;
                }
                return params.data.status === filterValue;
            },

            isFilterActive() {
                return filterValue !== undefined;
            },

            getModel() {
                if (!this.isFilterActive()) {
                    return null;
                }
                return { filterType: "text", type: "equals", filter: filterValue };
            },

            setModel(model: any) {
                const value = model == null ? undefined : model.filter || model.value;
                if (value !== filterValue) {
                    setFilterValue(value);
                }
            },
        };
    });

    useEffect(() => {
        props.filterChangedCallback();
    }, [filterValue]);

    return (
        <Box p={2}>
            <Select
                size="sm"
                value={filterValue ?? ""}
                onChange={event => {
                    const val = event.target.value;
                    setFilterValue(val === "" ? undefined : (val as DesignatedZoneType));
                }}
            >
                <option value="">All</option>
                {filterOptions}
            </Select>
        </Box>
    );
});

export default DesignatedZoneFilter;
